// useWizard — open/close state hook for a single wizard instance.
//
// FormDialog does NOT expose a wizard-state hook (its `stepIndex` is private),
// so this is a sibling hook owning ONLY the visibility state — the page
// component renders <Wizard open={isOpen} onClose={close} /> below the
// trigger button. FormDialog handles step state internally.

import { useCallback, useState } from "react";

export interface WizardHandle {
  /** The wizard_id from CHG-1241 (informational). */
  wizardId: string;
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export function useWizard(wizardId: string): WizardHandle {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return { wizardId, isOpen, open, close };
}
